export default __webpack_public_path__ + "static/pay_compare_comp3_active-1-1beb7bd804e999fa4350467bde9e9ae4.png";